import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as $ from 'jquery';


@Directive({
  selector: '[toggle-ng-multiselect]',
  providers: [NgModel]
})

export class NgMultiSelectDropDownDirective implements AfterViewInit {

  constructor(private elem: ElementRef, private ngModel: NgModel) {
  }

  ngAfterViewInit() {
    const that = this;
    that.elem.nativeElement.addEventListener('keydown', that.toggleMultiselctDDKeyboard);
  }

  toggleMultiselctDDKeyboard(event: KeyboardEvent){
    const KEY_UP = 38;
    const KEY_DOWN = 40;
    var multiselectDDElement = (<HTMLElement>event.target);
    if(event.altKey){
      if(event.keyCode === KEY_DOWN || event.keyCode === KEY_UP){
        let multisectDDChildNodes = multiselectDDElement.querySelectorAll('.dropdown-list');
        let hiddenAttrsFound = false;

        if(multisectDDChildNodes){
          for(let i = 0; i<multisectDDChildNodes.length; i++){
            if ((<HTMLElement>multisectDDChildNodes[i]).hasAttribute('hidden')){
              hiddenAttrsFound = true;
              break;
            }
          }

          for(let i = 0; i<multisectDDChildNodes.length; i++){
            if(hiddenAttrsFound){
              multisectDDChildNodes[i].removeAttribute('hidden');
            } else {
              multisectDDChildNodes[i].setAttribute('hidden', '');
            }
          }
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/directives/ngMultiSelectDropDown.directive.ts